// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"850":"97126df8","865":"117c0aa6","900":"d6bd4eb8","939":"9de857de"}[chunkId] + ".chunk.css";
};